import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SygnetInvoice from "./components/SygnetInvoice";

function App(){
  return(
    <div>
    <Router>
      <Routes>
      <Route path="/" element={<SygnetInvoice />} />
      <Route path="/SygnetInvoice" element={<SygnetInvoice/>} >
      </Route>
      </Routes>
    </Router>
    </div>
  );
}
export default App;
